import axios from 'axios';
import { handleResponse } from './HelperService';

const getSenderGoodIssue = (params, onSuccess, onError) => {
    const response = axios.get('v1/goodissues', { params });
    return handleResponse(response, onSuccess, onError);
};

const getSenderGoodIssueById = (id, onSuccess, onError) => {
    const response = axios.get('v1/goodissues/' + id);
    return handleResponse(response, onSuccess, onError);
};

const getRecipientGoodIssue = (params, onSuccess, onError) => {
    params.recipient = true;
    if (params.filter) {
        params.filter += ',status:OPEN'
    } else {
        params.filter = 'status:OPEN'
    }
    const response = axios.get('v1/goodissues', { params });
    return handleResponse(response, onSuccess, onError);
};

const getToWarehouses = (onSuccess, onError) => {
    const response = axios.get('v1/warehouses/to');
    return handleResponse(response, onSuccess, onError);
};

const getProductQty = (payload, onSuccess, onError) => {
    const response = axios.post('v1/productstock', payload);
    return handleResponse(response, onSuccess, onError);
}

const createGoodIssue = (payload, onSuccess, onError) => {
    const response = axios.post('v1/goodissues', payload);
    return handleResponse(response, onSuccess, onError);
}

const cancelGoodIssue = (id, onSuccess, onError) => {
    const response = axios.put('v1/goodissues/cancel/' + id);
    return handleResponse(response, onSuccess, onError);
}

const receiveGoodIssue = (id, payload, onSuccess, onError) => {
    const response = axios.post('v1/goodreceipts/' + id, payload);
    return handleResponse(response, onSuccess, onError);
}

const getGoodReceipt = (params, onSuccess, onError) => {
    const response = axios.get('v1/goodreceipts', { params });
    return handleResponse(response, onSuccess, onError);
};

const getGoodReceiptByID = (id, onSuccess, onError) => {
    const response = axios.get('v1/goodreceipts/' + id);
    return handleResponse(response, onSuccess, onError);
};

//

export {
    getSenderGoodIssue,
    getRecipientGoodIssue,
    getToWarehouses,
    getProductQty,
    createGoodIssue,
    getSenderGoodIssueById,
    cancelGoodIssue,
    receiveGoodIssue,
    getGoodReceipt,
    getGoodReceiptByID
};